import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledAccordionActionsPrimary,
  StyledItemPrimaryAvatarContent,
  StyledPrimaryButton
} from './style';

/**
 * Componente AccordionActionsItemPrimary que Contiene la información visible de AccordionActionsItem
 *
 * @param {React.Props} title - Primera parte del título del item que se pinta en negrita
 * @param {React.Props} subtitle - Segunda parte del título del item
 * @param {React.Props} type - 'button' o 'avatar' Define el tipo de children que se va a incluir
 * @param {React.Props} children - Espera recibir un 'AvatarPerson' o un 'Icon', es necesario definirlo en 'type' para que se muestre correctamente
 */
const AccordionActionsItemPrimary = ({ title, subtitle, children, type }) => (
  <StyledAccordionActionsPrimary type={type}>
    <strong>{title}</strong>
    <br />
    {subtitle && subtitle}
    {type === 'button' && (
      <StyledPrimaryButton transparent>{children}</StyledPrimaryButton>
    )}
    {type === 'avatar' && (
      <StyledItemPrimaryAvatarContent>
        {children}
      </StyledItemPrimaryAvatarContent>
    )}
  </StyledAccordionActionsPrimary>
);

AccordionActionsItemPrimary.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  type: PropTypes.oneOf(['button', 'avatar'])
};

AccordionActionsItemPrimary.defaultProps = {
  title: undefined,
  subtitle: undefined,
  type: 'button'
};

export default AccordionActionsItemPrimary;
